import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { validateEmail, getEmailErrorMessage } from '../../../utils/email';
import { passwordIsValid, getPasswordErrorMessage } from '../../../utils/password';
import { Input } from '../index';

const responseCode = {
  userExists: 'user_exists',
  invalidPassword: 'invalid_password'
};

class SignupPane extends Component {
  state = {
    email: '',
    password: '',
    buttonIsDisabled: false,
    error: {
      email: '',
      password: ''
    }
  };

  onChange = event => {
    const keyName = event.target.name;
    const value = event.target.value;
    const newState = {};
    newState[keyName] = value;
    this.setState(newState);
  };

  onSubmitError = details => {
    let error = {};
    if (details.code === responseCode.userExists) {
      error = { email: details.description, password: '' };
    }
    if (details.code === responseCode.invalidPassword) {
      error = details.policy
        ? // Needs to change how we get the string policy. We will provide 'policy' directly in err obj in auth0.js
          // However we need to better handle the password policy error.
          { email: '', password: details.policy }
        : { email: '', password: details.description };
    }
    this.setState({ error, buttonIsDisabled: false });
  };

  submitHandler = event => {
    event.preventDefault();
    const { email, password } = this.state;
    this.submit({ email, password });
    return false;
  };

  submit = data => {
    const error = { email: '', password: '' };
    this.setState({ error, buttonIsDisabled: true });
    const { email, password } = data;
    const { onSignup } = this.props;
    const emailIsValid = validateEmail(email);
    if (emailIsValid && passwordIsValid(password)) {
      onSignup(email, password, this.onSubmitError);
      return;
    }
    error.password = getPasswordErrorMessage(password);
    error.email = getEmailErrorMessage(email);
    this.setState({ error, buttonIsDisabled: false });
  };

  render() {
    const { email, password, error } = this.state;
    return (
      <div>
        <div className="signup--form--logo-container">
          <img
            className="auth0-logo"
            src="https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.svg"
            alt="Auth0"
          />
        </div>
        <h2 className="signup-form--header">Sign Up</h2>
        <Input
          label="Email"
          type="email"
          autoComplete="email"
          placeholder="yourname@email.com"
          name="email"
          onChange={this.onChange}
          value={email}
          required
          textError={error.email}
          icon={'icon-budicon-778'}
          onFocus={this.props.onInputFocus}
          onBlur={this.props.onInputBlur}
        />
        <Input
          label="Password"
          type="password"
          placeholder="....."
          name="password"
          onChange={this.onChange}
          value={password}
          required
          textError={error.password}
          icon={'icon-budicon-285'}
          onFocus={this.props.onInputFocus}
          onBlur={this.props.onInputBlur}
          inputPolicy={this.props.passwordPolicy}
        />
        <div className="form-box-footer">
          <p>
            By clicking any of the Sign Up buttons, <br /> I agree to the&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="/legal/ss-tos">
              terms of service
            </a>
          </p>
        </div>

        <button
          disabled={this.state.buttonIsDisabled}
          onMouseDown={this.submitHandler}
          className={classNames('btn', 'btn-lg', 'form-control', 'btn-success', {
            'btn-is-disabled-utils': this.state.buttonIsDisabled
          })}
        >
          SIGN UP
        </button>
        <style>{`
          .signup-form--header, .signup--form--logo-container {
            text-align: center;
          }
          .signup--form--logo-container {
            margin-top: 47px;
          }
          .signup-form--header {
            margin-top: 12px !important;
            padding-top: 0 !important;
            line-height: 39px !important;
          }
          .form-password-policy {
            padding: 20px;
          }
        `}</style>
      </div>
    );
  }
}

SignupPane.propTypes = {
  onSignup: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func,
  onInputBlur: PropTypes.func,
  passwordPolicy: PropTypes.array
};

SignupPane.defaultProps = {
  onInputFocus: () => '',
  onInputBlur: () => '',
  passwordPolicy: []
};
export default SignupPane;



// WEBPACK FOOTER //
// ./src/modules/signupForm/ab-show-password-policy/components/SignupPane/SignupPane.js